<template>
	<div>
		<b-alert variant="danger" :show="!!error" class="mb-3">{{error}}</b-alert>
		<b-form-row>
			<b-col cols="12" md="6" xl="4" class="mb-3 d-flex flex-column">
				<b-card class="mb-3" no-body>
					<b-card-body clas="d-flex flex-column">
						<h4 class="card-title">Default sounds</h4>
						<b-list-group flush class="flex-fill mx-n3" v-if="loading>0">
							<b-list-group-item v-for="idx in 2" :key="idx">
								<b-skeleton :width="`${70 + (idx % 3) * 10}%`"></b-skeleton>
							</b-list-group-item>
						</b-list-group>
						<b-list-group flush class="flex-fill mx-n3" v-else>
							<b-list-group-item class="d-flex" style="gap: .5em">
								<a href="#" @click="playTestAlert('alert')" v-b-tooltip.hover.left title="Play test alert"><b-icon icon="play-fill"></b-icon></a>
								<div class="flex-fill">
									Default alert sound
								</div>
								<b-avatar-group size="1.5rem" rounded overlap=".05" v-if="alertEventType">
									<b-avatar v-if="alertEventType.images?.length > 0" :src="alertEventType.images[0]?.url" v-b-tooltip.hover.bottom.v-info :title="`Has ${alertEventType.images?.length||0} image${alertEventType.images?.length == 1 ? '' : 's'} configured`" />
									<b-avatar v-if="alertEventType.sounds?.length > 0" v-b-tooltip.hover.bottom.v-info :title="`Has ${alertEventType.sounds?.length||0} sound${alertEventType.sounds?.length == 1 ? '' : 's'} configured`"><b-icon icon="music-note-beamed" class="text-muted"></b-icon></b-avatar>
								</b-avatar-group>
								<a href="#" @click="$refs.soundModal.show('alert')" v-b-tooltip.hover.right title="Edit alert media"><b-icon icon="pencil-fill"></b-icon></a>
							</b-list-group-item>
							<b-list-group-item class="d-flex" style="gap: .5em">
								<a href="#" @click="playTestAlert('default')" v-b-tooltip.hover.left title="Play test alert"><b-icon icon="play-fill"></b-icon></a>
								<div class="flex-fill">
									Default message sound
								</div>
								<b-avatar-group size="1.5rem" rounded overlap=".05" v-if="defaultEventType">
									<b-avatar v-if="defaultEventType.images?.length > 0" :src="defaultEventType.images[0]?.url" v-b-tooltip.hover.bottom.v-info :title="`Has ${defaultEventType.images?.length||0} image${defaultEventType.images?.length == 1 ? '' : 's'} configured`" />
									<b-avatar v-if="defaultEventType.sounds?.length > 0" v-b-tooltip.hover.bottom.v-info :title="`Has ${defaultEventType.sounds?.length||0} sound${defaultEventType.sounds?.length == 1 ? '' : 's'} configured`"><b-icon icon="music-note-beamed" class="text-muted"></b-icon></b-avatar>
								</b-avatar-group>
								<a href="#" @click="$refs.soundModal.show('default')" v-b-tooltip.hover.right title="Edit media"><b-icon icon="pencil-fill"></b-icon></a>
							</b-list-group-item>
						</b-list-group>
					</b-card-body>
				</b-card>
				<b-card class="flex-fill" no-body>
					<b-card-body class="d-flex flex-column">
						<h4 class="card-title">Value based gift alerts</h4>
						<b-list-group flush class="flex-fill mx-n3" v-if="loading>0">
							<b-list-group-item v-for="idx in 3" :key="idx">
								<b-skeleton :width="`${70 + (idx % 3) * 10}%`"></b-skeleton>
							</b-list-group-item>
						</b-list-group>
						<b-list-group flush class="flex-fill mx-n3" v-else>
							<b-list-group-item class="d-flex" style="gap: .5em">
								<a href="#" @click="playTestAlert('gift', { below: giftThresholds?.length &gt; 0 ? giftThresholds[0].amount : null, currency: $parent.$parent.user.currency_code })" v-b-tooltip.hover.left title="Play test alert"><b-icon icon="play-fill"></b-icon></a>
								<div class="flex-fill">
									Gifts from {{generateValueString(0, $parent.$parent.user.currency_code)}}
								</div>
								<b-avatar-group size="1.5rem" rounded overlap=".05" v-if="giftEventType">
									<b-avatar v-if="giftEventType.images?.length > 0" :src="giftEventType.images[0]?.url" v-b-tooltip.hover.bottom.v-info :title="`Has ${giftEventType.images?.length||0} image${giftEventType.images?.length == 1 ? '' : 's'} configured`" />
									<b-avatar v-if="giftEventType.sounds?.length > 0" v-b-tooltip.hover.bottom.v-info :title="`Has ${giftEventType.sounds?.length||0} sound${giftEventType.sounds?.length == 1 ? '' : 's'} configured`"><b-icon icon="music-note-beamed" class="text-muted"></b-icon></b-avatar>
								</b-avatar-group>
								<a href="#" @click="$refs.soundModal.show('gift')" v-b-tooltip.hover.right title="Edit alert media"><b-icon icon="pencil-fill"></b-icon></a>
							</b-list-group-item>
							<b-list-group-item v-for="(a, idx) in giftThresholds" :key="idx" class="d-flex" style="gap: .5em">
								<a href="#" @click="playTestAlert('gift', { threshold: a.amount, below: idx &lt; giftThresholds.length - 1 ? giftThresholds[idx+1].amount : null, currency: $parent.$parent.user.currency_code })" v-b-tooltip.hover.left title="Play test alert"><b-icon icon="play-fill"></b-icon></a>
								<div class="flex-fill">
									{{`From ${generateValueString(a.amount, $parent.$parent.user.currency_code)}${idx &lt; giftThresholds.length - 1 ? ` to under ${generateValueString(giftThresholds[idx+1].amount, $parent.$parent.user.currency_code)}` : ''}`}}
								</div>
								<b-avatar-group size="1.5rem" rounded overlap=".05">
									<b-avatar v-if="a.files?.filter(f => f.mime_major == 'image')?.length > 0" :src="a.files?.filter(f => f.mime_major == 'image')?.[0]?.url" v-b-tooltip.hover.left.v-info :title="`Has ${a.files?.filter(f => f.mime_major == 'image')?.length||0} image${a.files?.filter(f => f.mime_major == 'image')?.length == 1 ? '' : 's'} configured`" />
									<b-avatar v-if="a.files?.filter(f => f.mime_major == 'audio')?.length > 0" v-b-tooltip.hover.right.v-info :title="`Has ${a.files?.filter(f => f.mime_major == 'audio')?.length||0} sound${a.files?.filter(f => f.mime_major == 'audio')?.length == 1 ? '' : 's'} configured`"><b-icon icon="music-note-beamed" class="text-muted"></b-icon></b-avatar>
								</b-avatar-group>
								<a href="#" @click="editThreshold(a.id)" v-b-tooltip.hover.right title="Edit gift alert threshold"><b-icon icon="pencil-fill"></b-icon></a>
							</b-list-group-item>
						</b-list-group>
						<div class="text-center">
							<b-button variant="primary" @click="editThreshold()">Add threshold</b-button>
						</div>
					</b-card-body>
				</b-card>
			</b-col>
			<b-col cols="12" md="6" xl="4" class="mb-3">
				<b-card class="h-100">
					<h4 class="card-title">Alerts</h4>
					<b-list-group flush class="flex-fill mx-n3 mb-n3" v-if="loading>0">
						<b-list-group-item v-for="idx in 11" :key="idx">
							<b-skeleton :width="`${70 + (idx % 3) * 10}%`"></b-skeleton>
						</b-list-group-item>
					</b-list-group>
					<b-list-group flush class="flex-fill mx-n3 mb-n3" v-else>
						<b-list-group-item v-for="(a, idx) in alertTypes" :key="idx" class="d-flex" style="gap: .5em" :class="a.status == 'disabled' && 'text-muted'">
							<span v-if="a.status == 'disabled'" v-b-tooltip.hover.left title="Alert type disabled"><b-icon icon="x-circle" variant="muted"></b-icon></span>
							<a v-else href="#" @click="playTestAlert(a.event_type)" v-b-tooltip.hover.left title="Play test alert"><b-icon icon="play-fill"></b-icon></a>
							<div class="flex-fill">{{a.event_name}}</div>

							<b-avatar-group size="1.5rem" rounded overlap=".05">
								<b-avatar v-if="a.images?.length > 0" :src="a.images[0]?.url" v-b-tooltip.hover.bottom.v-info :title="`Has ${a.images?.length||0} image${a.images?.length == 1 ? '' : 's'} configured`" />
								<b-avatar v-if="a.sounds?.length > 0" v-b-tooltip.hover.bottom.v-info :title="`Has ${a.sounds?.length||0} sound${a.sounds?.length == 1 ? '' : 's'} configured`"><b-icon icon="music-note-beamed" class="text-muted"></b-icon></b-avatar>
							</b-avatar-group>

							<a href="#" @click="$refs.soundModal.show(a.event_type)" v-b-tooltip.hover.right title="Edit alert media"><b-icon icon="pencil-fill"></b-icon></a>
						</b-list-group-item>
					</b-list-group>
				</b-card>
			</b-col>
			<b-col cols="12" md="6" xl="4" class="mb-3">
				<b-card class="h-100">
					<h4 class="card-title">Messages</h4>
					<b-list-group flush class="flex-fill mx-n3 mb-n3" v-if="loading>0">
						<b-list-group-item v-for="idx in 11" :key="idx">
							<b-skeleton :width="`${70 + (idx % 3) * 10}%`"></b-skeleton>
						</b-list-group-item>
					</b-list-group>
					<b-list-group flush class="flex-fill mx-n3 mb-n3" v-else>
						<b-list-group-item v-for="(a, idx) in eventTypes" :key="idx" class="d-flex" style="gap: .5em" :class="a.status == 'disabled' && 'text-muted'">
							<span v-if="a.status == 'disabled'" v-b-tooltip.hover.left title="Message type disabled"><b-icon icon="x-circle" variant="muted"></b-icon></span>
							<a v-else href="#" @click="playTestAlert(a.event_type)" v-b-tooltip.hover.left title="Send test message"><b-icon icon="play-fill"></b-icon></a>
							<div class="flex-fill">{{a.event_name}}</div>
							<b-avatar-group size="1.5rem" rounded overlap=".05">
								<b-avatar v-if="a.images?.length > 0" :src="a.images[0]?.url" v-b-tooltip.hover.bottom.v-info :title="`Has ${a.images?.length||0} image${a.images?.length == 1 ? '' : 's'} configured`" />
								<b-avatar v-if="a.sounds?.length > 0" v-b-tooltip.hover.bottom.v-info :title="`Has ${a.sounds?.length||0} sound${a.sounds?.length == 1 ? '' : 's'} configured`"><b-icon icon="music-note-beamed" class="text-muted"></b-icon></b-avatar>
							</b-avatar-group>
							<a href="#" @click="$refs.soundModal.show(a.event_type)" v-b-tooltip.hover.right title="Edit event media" size="sm"><b-icon icon="pencil-fill"></b-icon></a>
						</b-list-group-item>
					</b-list-group>
				</b-card>
			</b-col>
		</b-form-row>
		<sound-modal ref="soundModal" @saved="reloadUserEventTypes()"></sound-modal>
		<b-modal ref="thresholdEditModal" title="Edit gift alert threshold">
			<b-form @submit.stop.prevent="saveThreshold(); return false" id="towerEditForm" v-if="curGiftThreshold">
				<b-form-row>
					<b-col>
						<b-form-group label="Minimum">
							<b-form-input v-model.number="curGiftThreshold.amount" required/>
						</b-form-group>
					</b-col>
				</b-form-row>
				<b-form-row>
					<b-col>
						<b-form-group label="Media" description="Sounds and images">
							<pipi-pupu-multi-file v-model="curGiftThreshold.files" accept="image/*,audio/*" />
						</b-form-group>
					</b-col>
				</b-form-row>
			</b-form>
			<template #modal-footer="{cancel}">
				<div class="w-100">
					<b-alert variant="danger" :show="!!saveError">{{saveError}}</b-alert>
					<div class="float-left" v-if="curGiftThreshold?.id">
						<a href="#" @click="confirmRemoveThreshold(curGiftThreshold.id)" v-b-tooltip.hover.left.v-danger title="Remove gift threshold" class="text-danger"><b-icon icon="trash-fill"></b-icon> Delete</a>
					</div>
					<div class="float-right">
						<b-spinner v-show="saving > 0" small label="Spinning" class="mr-3"></b-spinner>
						<b-button variant="success" type="submit" form="towerEditForm" class="mr-2">
							Save
						</b-button>
						<b-button @click="cancel()">
							Cancel
						</b-button>
					</div>
				</div>
			</template>
		</b-modal>
	</div>
</template>

<script>
import SoundModal from '@/views/Widgets/Modal/Sound.vue';
import util from '@/util.js';
import PipiPupuMultiFile from '@/components/PipiPupuMultiFile.vue';

export default {
	data() { return {
		loading: 0,
		error: null,
		alertTypes: [],
		eventTypes: [],
		alertEventType: null,
		defaultEventType: null,
		giftEventType: null,
		giftThresholds: [],
		curGiftThreshold: null,
		saving: 0,
		saveError: null,
	}; },
	components: {
		SoundModal,
		PipiPupuMultiFile,
	},
	async mounted() {
		try {
			this.loading++;
			this.error = null;
			this.saveError = null;
			this.giftThresholds = await this.$api.get('giftThresholds');
			await this.loadUserEventTypes();
		} catch(e) {
			console.error(e);
			this.error = e;
		} finally {
			this.loading--;
		}
	},
	methods: {
		async loadUserEventTypes() {
			const eventTypes = await this.$api.get('userEventTypes');
			this.alertTypes = eventTypes.filter(t => t.event_alert_type == 'alert' && t.event_type != 'gift' && t.event_type != 'alert');
			this.giftEventType = eventTypes.find(t => t.event_type == 'gift');
			this.eventTypes = eventTypes.filter(t => t.event_alert_type == 'event' && t.event_type != 'default');
			this.alertEventType = eventTypes.find(t => t.event_type == 'alert');
			this.defaultEventType = eventTypes.find(t => t.event_type == 'default');
		},
		async reloadUserEventTypes() {
			try {
				this.loading++;
				this.error = null;
				await this.loadUserEventTypes();
			} catch(e) {
				console.error(e);
				this.error = e;
			} finally {
				this.loading--;
			}
		},
		generateValueString(value, currency) {
			return util.generateValueString(value, currency);
		},
		async editThreshold(id) {
			this.$refs.thresholdEditModal.show();
			if(id) {
				this.curGiftThreshold = await this.$api.get(`giftThreshold/${id}`);
			} else {
				const amount = (Math.max(0, ...this.giftThresholds.map(t => t.amount)) || 0) + 5;
				this.curGiftThreshold = {
					amount,
					files: [],
				};
			}
		},
		async reloadGiftThresholds() {
			try {
				this.loading++;
				this.error = null;
				this.giftThresholds = await this.$api.get('giftThresholds');
			} catch(e) {
				console.error(e);
				this.error = e;
			} finally {
				this.loading--;
			}
		},
		async saveThreshold() {
			try {
				this.saving++;
				this.saveError = null;
				if(this.curGiftThreshold.id)
					await this.$api.patch(`giftThreshold/${encodeURIComponent(this.curGiftThreshold.id)}`, this.curGiftThreshold);
				else
					await this.$api.post(`giftThreshold`, this.curGiftThreshold);
				this.$refs.thresholdEditModal.hide();
				this.reloadGiftThresholds();
			} catch(e) {
				console.error(e);
				this.saveError = e;
			} finally {
				this.saving--;
			}
		},
		async confirmRemoveThreshold(id) {
			try {
				const confirm = await this.$bvModal.msgBoxConfirm('Are you sure you want to remove this threshold?', {
					title: 'Please Confirm',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'danger',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true,
				});
				if(confirm) {
					this.$refs.thresholdEditModal.hide();
					try {
						this.loading++;
						this.error = null;
						await this.$api.delete(`giftThreshold/${id}`);
						this.reloadGiftThresholds();
					} catch(e) {
						console.error(e);
						this.error = e;
					} finally {
						this.loading--;
					}
				}
			} catch(e) {
				console.error(e);
			}
		},
		async playTestAlert(type, data) {
			try {
				await this.$api.post('alerts/test', { type, data });
			} catch(e) {
				console.error(e);
				this.$bvToast.toast('Could not send test alert: '+(e.error||String(e)), {
					title: 'Error',
					variant: 'danger',
					solid: true,
				});
			}
		},
	},
};
</script>
